<template>
    <div class="dropdown-menu-project" v-if="setup != null" id="dropdown-menu-project" :class="{'open' : openSendwich}">
        <div class="container">
            <div class="drop-down-container">
                <burgerNavMain></burgerNavMain>
                    <!-- <div class="drop-down-mobile-header" v-if="isMobileChecker">
                        <div class="lang-selector">
                            <ul>
                                <li :class="{'active' : globalLang == 'kz/'}"><a href="#" @click.prevent="setLocale('kz/')">Каз</a></li>
                                <li :class="{'active' : globalLang == ''}"><a href="#" @click.prevent="setLocale('')">Рус</a></li>
                            </ul>
                        </div>
                        <div class="phone">
                            <a :href="'tel:' + salesCard.project_shablon_fields.shablon_project_phone">
                                <div class="icon-phone">
                                    <svgIcon name="phone" />
                                </div>
                                <p>{{salesCard.project_shablon_fields.shablon_project_phone}}</p>
                            </a>
                        </div>
                    </div> -->

                <!-- <div class="col-right" v-if="!isMobileChecker && salesCard.project_shablon_fields.office_card.length">
                    <div class="office-item">
                        <h3>{{salesCard.project_shablon_fields.shablon_project_adres.title}}</h3>
                        <p><span>{{salesCard.project_shablon_fields.shablon_project_adres.city}}</span>{{salesCard.project_shablon_fields.shablon_project_adres.adres}}</p>
                    </div>
                    <a href="#" v-scroll-to="{
                        el: '#land-form-top',
                        offset: offsetResponse
                    }" class="btn-call" @click="closeMobileMenu">{{salesCard.project_shablon_fields.shablon_form_btn}}</a>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import burgerNavMain from '@/components/nav-main/burger-nav-main.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'Burger-Menu',
        components: {
            svgIcon,
            burgerNavMain,
            // shablongNav,
        },
        data () {
            return {
                iSmobile: false,
                openSelectLang: false,
                dataLang: '',
                langOpen: false,
                globalLang: window.GlobalLang, 
                // projectHost: window.host,
                offset: -150,
            }
        },
        computed: mapGetters({
            // salesCard: 'loadSalesCardContent',
            setup: 'loadPageSetUp',
            openSendwich: 'loadOpenSendwich',
            isMobileChecker: 'loadIsMobileChecker',
            // offsetResponse: 'loadOffsetResponse',
        }),
        methods: {
            closeMobileMenu() {
                this.$store.commit('Open_Sendwich', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/burger-menu/burger-menu.scss';
    // @import '@/styles/components/burger-menu/burger-menu-respond.scss';
</style>